import Sortable from 'sortablejs';

import * as Model from '../model.js';
import appView from './appView.js';
import * as Database from './database.js';
import previewView from './markups.js';
import {
  TODOSUCESS,
  FAILEDMESSAGE,
  SUCCESSUPDATE,
  ITEMSDELETED,
  LISTDELETECONFIRM,
} from '../config.js';

class ScrumBoard extends appView {
  _containterItem = '.card';

  constructor() {
    super();
    this.initialize();
    this.cardId = null;
    this.cardSection = null;
    this.cardOrder = null;
  }

  async initialize() {
    try {
      await this._setupEventListeners();
    } catch (err) {
      this.failedMessageInfo(FAILEDMESSAGE);
    }
  }

  async _setupEventListeners() {
    try {
      await this._renderTaskContainers();
      await this._renderTaskCards();
      this._hideClearAllBtn();
      this._taskSortable();
      this._addNewListModal();
      this._addNewList();
      this._renderFunctions();
    } catch (err) {
      this.failedMessageInfo(FAILEDMESSAGE);
    }
  }

  _taskSortable() {
    const sortableElements = document.querySelectorAll(
      '.connect-sorting-content'
    );

    if (sortableElements) {
      sortableElements.forEach(element => {
        new Sortable(element, {
          group: 'connect-sorting-content',
          ghostClass: 'sortable-placeholder',
          animation: 150,
          forcePlaceholderSize: true,
          onEnd: function (event) {
            const parentContainer = event.from.closest('.task-list-container');
            const finalContainer = event.to.closest('.task-list-container');

            const parentSection = parentContainer.getAttribute('data-section');
            const finalSection = finalContainer.getAttribute('data-section');

            this._updateCards(finalContainer, finalSection)
              .then(validSections => {
                this._updateTaskAttribute(validSections, finalSection);

                return this._updateCards(parentContainer, parentSection);
              })
              .then(validParentSections => {
                this._updateTaskAttribute(validParentSections, parentSection);
                this._hideClearAllBtn();
              })
              .catch(err => {
                console.error(err);
              });
          }.bind(this),
        });
      });
    }
  }

  _updateCards(container, section) {
    const cardTasks = container.querySelectorAll('.card');
    const updatePromises = [];

    cardTasks.forEach((card, index) => {
      const cardId = card.getAttribute('data-card-id');

      const options = { tasksection: section, order: index };

      const updatePromise = Database.updateItemInDatabase(
        cardId,
        'scrumboard',
        options
      )
        .then(() => ({ cardId, order: options.order }))
        .catch(err => {
          this.failedMessageInfo(FAILEDMESSAGE);
          return null;
        });

      updatePromises.push(updatePromise);
    });

    return Promise.all(updatePromises);
  }

  _containerSortable() {
    const sortableElement = document.querySelector('.task-list-section');

    if (sortableElement) {
      new Sortable(sortableElement, {
        connectWith: '.task-list-container',
        draggable: '.task-list-container',
        ghostClass: 'sortable-placeholder',
        chosenClass: 'sortable-chosen',
        animation: 150,
        forcePlaceholderSize: true,
        onUpdate: function (event) {
          const containerElements = document.querySelectorAll(
            '.task-list-container'
          );
          const updatePromises = [];

          containerElements.forEach((container, index) => {
            const containerId = container.getAttribute('data-section');
            const newPosition = { order: index };
            console.log(containerId, newPosition);

            const updatePromise = Database.updateItemInDatabase(
              containerId,
              'scrumlist',
              newPosition
            )
              .then(() => ({ containerId, order: newPosition.order }))
              .catch(err => {
                this.failedMessageInfo(FAILEDMESSAGE);
                return null;
              });

            updatePromises.push(updatePromise);
          });

          Promise.all(updatePromises)
            .then(sections => {
              const validSections = sections.filter(
                section => section !== null
              );
              this._updateContainerAttribute(validSections);
            })
            .catch(err => {
              console.error(err);
            });
        }.bind(this),
      });
    }
  }

  _updateContainerAttribute(sections) {
    sections.forEach(({ containerId, order }) => {
      const container = document.querySelector(
        `[data-section="${containerId}"]`
      );
      container.dataset.order = order;
    });
  }

  _updateTaskAttribute(sections, parentSection) {
    sections.forEach(({ cardId, order }) => {
      // console.log(cardId, order, parentSection);
      const cardList = document.querySelector(`[data-card-id="${cardId}"]`);
      cardList.dataset.order = order;
      cardList.dataset.listId = parentSection;
    });
  }

  async _renderTaskContainers() {
    try {
      const listParent = document.querySelector('.task-list-section');
      if (!listParent) return;

      const storedOrder = await Database.getAllItemsFromDatabase('scrumlist');
      const sortedItems = this._sortDataByOrder(storedOrder);

      for (const item of sortedItems) {
        const markup = previewView.scrumListMarkup(item);

        listParent.insertAdjacentHTML('beforeend', markup);
      }
    } catch (err) {
      this.failedMessageInfo(FAILEDMESSAGE);
    }
  }

  async _renderTaskCards() {
    try {
      const containers = document.querySelectorAll('.task-list-container');

      for (const data of containers) {
        const listAtrr = data.getAttribute('data-section');
        const filterFunction = item => item.tasksection === listAtrr;

        const storedData = await Database.getAllItemsFromDatabase(
          'scrumboard',
          filterFunction
        );
        const sortedOrder = this._sortDataByOrder(storedData);
        // console.log(sortedOrder);
        await this.displayScrum(sortedOrder, listAtrr, true);
      }
    } catch (err) {
      this.failedMessageInfo(FAILEDMESSAGE);
    }
  }

  _sortDataByOrder(data) {
    return data.sort((a, b) => a.order - b.order);
  }

  _addNewListModal() {
    const listBtn = document.getElementById('add-list');

    if (listBtn) {
      $(listBtn)
        .off('click')
        .on('click', function (event) {
          event.preventDefault();
          document.querySelector('.add-list').style.display = 'block';
          document.querySelector('.edit-list').style.display = 'none';
          document.querySelector('.edit-list-title').style.display = 'none';
          document.querySelector('.add-list-title').style.display = 'block';
          $('#addListModal').modal('show');
        });
    }
  }

  _addNewList() {
    const listBtn = document.querySelector('.add-list');

    if (listBtn) {
      const self = this;
      $(listBtn)
        .off('click')
        .on('click', async function (event) {
          try {
            const listIndex = await Database.getObjectStoreLength('scrumlist');

            const data = Model.createNewList(false, null, listIndex);

            const storeData = await Database.addItemtoDatabase(
              data,
              'scrumlist'
            );

            const markup = previewView.scrumListMarkup(storeData);
            document
              .querySelector('.task-list-section')
              .insertAdjacentHTML('beforeend', markup);
          } catch (err) {
          } finally {
            $('#addListModal').modal('hide');
            document.getElementById('s-list-name').value = '';
            self._renderFunctions();
          }
        });
    }
  }

  _renderFunctions() {
    this._taskSortable();
    this._editList();
    this._deleteList();
    this._clearCardList();
    this._taskEdit();
    this._addTaskClick();
    this._taskDelete();
    this._containerSortable();
    this._onEditTaskClick();
  }

  _taskDelete() {
    const deleteBtn = document.querySelectorAll('.card .s-task-delete');

    if (deleteBtn) {
      const self = this;

      $(deleteBtn)
        .off('click')
        .on('click', function (event) {
          event.preventDefault();

          const cardParent = event.target.closest('.card');

          $('#deleteConformation').modal('show');

          document
            .querySelectorAll('[data-remove="task"]')
            .forEach(function (btn) {
              btn.addEventListener('click', async function (event) {
                event.preventDefault();
                try {
                  const cardId = cardParent.getAttribute('data-card-id');

                  await Database.deleteItemFromDatabase(cardId, 'scrumboard');

                  cardParent.remove();
                  self.successMessageInfo(ITEMSDELETED);
                } catch (err) {
                  self.failedMessageInfo(FAILEDMESSAGE);
                } finally {
                  $('#deleteConformation').modal('hide');
                  self._hideClearAllBtn();
                }
              });
            });
        });
    }
  }

  _taskEdit() {
    const editBtn = document.querySelectorAll('.card .s-task-edit');

    if (editBtn) {
      const self = this;
      $(editBtn)
        .off('click')
        .on('click', function (event) {
          event.preventDefault();
          const outerThis = this;

          const taskTitleElement = outerThis
            .closest('.card')
            .querySelector('h4');
          const taskTextElement = outerThis
            .closest('.card')
            .querySelector('p:not([class="progress-count"])');
          const progressElement = outerThis
            .closest('.card')
            .querySelector('div.progress-bar');

          document.querySelector('.add-task-title').style.display = 'none';
          document.querySelector('.edit-task-title').style.display = 'block';

          document.querySelector('[data-btnfn="addTask"]').style.display =
            'none';
          document.querySelector('[data-btnfn="editTask"]').style.display =
            'block';

          const taskTitle =
            taskTitleElement?.getAttribute('data-taskTitle') ?? '';
          const taskText = taskTextElement?.getAttribute('data-taskText') ?? '';
          const taskProgress =
            progressElement?.getAttribute('data-progressState') ?? '';

          document.getElementById('s-task').value = taskTitle;
          document.getElementById('s-text').value = taskText;
          document.getElementById('s-progress').value = +taskProgress || '';
          self.cardId = outerThis.closest('.card').getAttribute('data-card-id');
          self.cardSection = outerThis
            .closest('.card')
            .getAttribute('data-list-id');
          self.cardOrder = outerThis
            .closest('.card')
            .getAttribute('data-order');

          $('#addTaskModal').modal('show');
          self._hideModalInfo();
        });
    }
  }

  _onEditTaskClick() {
    const editBtn = document.querySelector('[data-btnfn="editTask"]');

    if (editBtn) {
      const self = this;
      $(editBtn)
        .off('click')
        .on('click', async function (event) {
          event.preventDefault();
          try {
            const containerElement = document.querySelector(
              `.connect-sorting-content .card[data-card-id="${self.cardId}"]`
            );

            const options = {
              id: self.cardId,
              tasksection: self.cardSection,
              order: self.cardOrder,
            };

            const data = Model.createScrumBoard(options, true);

            await Database.updateItemInDatabase(
              self.cardId,
              'scrumboard',
              data
            );
            const markup = previewView.scrumBoardMarkup(data);
            self.update(data, markup, containerElement);

            self.successMessageInfo(SUCCESSUPDATE);
          } catch (err) {
            self.failedMessageInfo(FAILEDMESSAGE);
          } finally {
            self.cardId = null;
            self.cardSection = null;
            self.cardOrder = null;
            $('#addTaskModal').modal('hide');
            self._hideModalInfo();
            self._renderFunctions();
          }
        });
    }
  }

  _deleteList() {
    const deleteBtn = document.querySelectorAll('.list-delete');

    if (deleteBtn) {
      const self = this;
      $(deleteBtn)
        .off('click')
        .on('click', function (event) {
          event.preventDefault();
          const listContainer = event.target.closest(
            '[data-connect="sorting"]'
          );

          $('#deleteConformation')
            .find('.modal-body p')
            .text(LISTDELETECONFIRM);

          $('#deleteConformation').modal('show');

          document
            .querySelector('[data-remove="task"]')
            .addEventListener('click', async function () {
              try {
                const listId = listContainer.getAttribute('data-section');
                const cardTasks = listContainer.querySelectorAll(
                  '.connect-sorting-content .card'
                );
                const trashCards = [];
                await Database.deleteItemFromDatabase(listId, 'scrumlist');
                for (const card of cardTasks) {
                  const cardId = card.getAttribute('data-card-id');
                  trashCards.push(cardId);
                }
                await Database.deleteMultipleItemsFromDatabase(
                  trashCards,
                  'scrumboard'
                );
                listContainer.remove();
                self.successMessageInfo(SUCCESSUPDATE);
              } catch (err) {
                self.failedMessageInfo(FAILEDMESSAGE);
              } finally {
                $('#deleteConformation').modal('hide');
              }
            });
        });
    }
  }

  _hideClearAllBtn() {
    const containerElement = document.querySelectorAll('.task-list-container');

    containerElement.forEach(container => {
      const cardArr = container.querySelector('.list-clear-all');
      const containerCard = container.querySelectorAll(
        '.connect-sorting-content .card'
      );

      if (containerCard.length === 0 || containerCard.length === 1) {
        cardArr.style.display = 'none';
      } else if (containerCard.length > 1) {
        cardArr.style.display = 'block';
      }
    });
  }

  _clearCardList() {
    const clearBtn = document.querySelectorAll('.list-clear-all');
    if (clearBtn) {
      const self = this;
      $(clearBtn)
        .off('click')
        .on('click', function (event) {
          event.preventDefault();
          const listContainer = event.target
            .closest('[data-connect="sorting"]')
            .querySelectorAll('.connect-sorting-content .card');

          $('#deleteConformation').modal('show');

          document
            .querySelector('[data-remove="task"]')
            .addEventListener('click', async function () {
              try {
                const trashCards = [];

                for (const card of listContainer) {
                  const cardId = card.getAttribute('data-card-id');
                  trashCards.push(cardId);
                }
                await Database.deleteMultipleItemsFromDatabase(
                  trashCards,
                  'scrumboard'
                );
                listContainer.forEach(list => list.remove());
                self.successMessageInfo(SUCCESSUPDATE);
              } catch (err) {
                self.failedMessageInfo(FAILEDMESSAGE);
              } finally {
                $('#deleteConformation').modal('hide');
              }
            });
        });
    }
  }

  _editList() {
    const editBtn = document.querySelectorAll('.list-edit');

    if (editBtn) {
      const self = this;
      editBtn.forEach(function (element) {
        element.removeEventListener('click', handleListEdit);
        element.addEventListener('click', handleListEdit);
      });

      function handleListEdit(event) {
        event.preventDefault();

        const outerThis = event.target;
        const listContainer = outerThis.closest('[data-connect="sorting"]');
        const listTitleElement = listContainer.querySelector('.s-heading');

        document.querySelector('.add-list').style.display = 'none';
        document.querySelector('.edit-list').style.display = 'block';
        document.querySelector('.add-list-title').style.display = 'none';
        document.querySelector('.edit-list-title').style.display = 'block';

        const listTitle = listTitleElement.getAttribute('data-listTitle');
        document.getElementById('s-list-name').value = listTitle;

        document
          .querySelector('.edit-list')
          .removeEventListener('click', handleInnerListEdit);
        document
          .querySelector('.edit-list')
          .addEventListener('click', handleInnerListEdit);

        async function handleInnerListEdit(event) {
          try {
            const innerThis = event.target;
            const editedListTitle =
              document.getElementById('s-list-name').value;
            const dataSection = listTitleElement
              .closest('.task-list-container')
              .getAttribute('data-section');
            const dataOrder = listTitleElement
              .closest('.task-list-container')
              .getAttribute('data-order');

            const options = {
              section: dataSection,
              order: dataOrder,
            };

            const data = Model.createNewList(true, options);

            await Database.updateItemInDatabase(dataSection, 'scrumlist', data);

            listTitleElement.innerHTML = editedListTitle;
            listTitleElement.setAttribute('data-listTitle', editedListTitle);
            self.successMessageInfo(SUCCESSUPDATE);
          } catch (err) {
            self.failedMessageInfo(FAILEDMESSAGE);
          } finally {
            $('#addListModal').modal('hide');
            $('#s-list-name').val('');
          }
        }

        $('#addListModal').modal('show');
        $('#addListModal').on('hidden.bs.modal', function (e) {
          $('#s-list-name').val('');
        });
      }
    }
  }

  _hideModalInfo() {
    const addTaskModal = document.getElementById('addTaskModal');
    const addListModal = document.getElementById('addListModal');

    if (addTaskModal || addListModal) {
      $(addTaskModal, addListModal).on('hidden.bs.modal', function (event) {
        $('input,textarea').val('');
      });
    }
  }

  _addTaskClick() {
    const addTaskButtons = document.querySelectorAll('.addTask');

    if (addTaskButtons) {
      const self = this;
      addTaskButtons.forEach(button => {
        button.addEventListener('click', function (event) {
          event.preventDefault();
          const parentElement = this.closest('[data-connect="sorting"]');
          const getParentElement = parentElement.getAttribute('data-section');

          document.querySelector('.edit-task-title').style.display = 'none';
          document.querySelector('.add-task-title').style.display = 'block';
          document.querySelector('[data-btnfn="addTask"]').style.display =
            'block';
          document.querySelector('[data-btnfn="editTask"]').style.display =
            'none';

          // $('.addTaskAccordion .collapse').collapse('hide');
          $('#addTaskModal').modal('show');
          self._renderNewTask(getParentElement);
        });
      });
    }
  }

  _renderNewTask(getParent) {
    const btnClass = document.querySelector('[data-btnfn="addTask"]');

    if (btnClass) {
      const self = this;

      $('[data-btnfn="addTask"]')
        .off('click')
        .on('click', async function (event) {
          const tasklength = await Database.getObjectStoreLength('scrumboard');

          const options = {
            tasksection: getParent,
            order: tasklength,
          };

          const data = Model.createScrumBoard(options);

          try {
            await Database.addItemtoDatabase(data, 'scrumboard');
            await self.displayScrum(data, getParent);

            self.successMessageInfo(TODOSUCESS);
          } catch (err) {
            self.failedMessageInfo(FAILEDMESSAGE);
          } finally {
            $('#addTaskModal').modal('hide');
            self._taskDelete();
            self._taskEdit();
            self._hideModalInfo();
            self._hideClearAllBtn();
          }
        });
    }
  }

  async displayScrum(data, getParent, newRender = false) {
    if (newRender) {
      data.forEach(item => {
        this._displayCards(item, getParent);
      });
    } else {
      this._displayCards(data, getParent);
    }
  }

  _displayCards(data, getParent) {
    const markup = previewView.scrumBoardMarkup(data);
    const parent = document.querySelector(
      `[data-section="${getParent}"] .connect-sorting-content`
    );
    parent.insertAdjacentHTML('beforeend', markup);
  }
}

new ScrumBoard();
